import React from "react";

export default function SecondaryButton({ children, className = "", ...props }) {
  return (
    <button
      type="button"
      {...props}
      className={
        `
        w-[358px] h-[48px] px-6 py-3 
        flex justify-center items-center
        bg-white border border-[#006CE0] 
        rounded-[7px] box-border cursor-pointer
        transition-colors duration-300
        
        hover:bg-[rgba(1,19,176,0.03)]

        disabled:cursor-not-allowed
        disabled:opacity-50
        disabled:hover:bg-white
        disabled:pointer-events-none
        ` + className
      }
    >
      {children}
    </button>
  );
}